function normalizeBrandValue(value: unknown): string | undefined {
    if (typeof value === 'string') {
        const brand = value.trim();
        return brand.length > 0 ? brand : undefined;
    }

    return undefined;
}

/**
 * Reads the brand label from a search suggestion product.
 *
 * Prefers `c_brand` from the SCAPI `search_suggestion.modifyGETResponse` hook
 * (SuggestedProduct has no standard `brand` field). Falls back to `brand` if present.
 */
export function resolveSearchSuggestionBrand(product: Record<string, unknown>): string | undefined {
    return normalizeBrandValue(product.c_brand) ?? normalizeBrandValue(product.brand);
}
